// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file history.proto (package history.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file history.proto.
 */
export const file_history: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message history.v1.BucketedHistoryRequest
 */
export type BucketedHistoryRequest = Message<"history.v1.BucketedHistoryRequest"> & {
  /**
   * @generated from field: string entity = 1;
   */
  entity: string;

  /**
   * @generated from field: string project = 2;
   */
  project: string;

  /**
   * @generated from field: string run_filter = 3;
   */
  runFilter: string;

  /**
   * @generated from field: repeated string specs = 4;
   */
  specs: string[];

  /**
   * @generated from field: optional int32 limit = 6;
   */
  limit?: number | undefined;

  /**
   * @generated from field: optional string order = 7;
   */
  order?: string | undefined;

  /**
   * @generated from field: repeated string current_runs = 8;
   */
  currentRuns: string[];

  /**
   * @generated from field: optional string last_updated = 9;
   */
  lastUpdated?: string | undefined;

  /**
   * @generated from field: repeated string config_keys = 10;
   */
  configKeys: string[];

  /**
   * @generated from field: repeated string summary_keys = 11;
   */
  summaryKeys: string[];

  /**
   * @generated from field: repeated string pinned_runs = 12;
   */
  pinnedRuns: string[];
};

/**
 * Describes the message history.v1.BucketedHistoryRequest.
 * Use `create(BucketedHistoryRequestSchema)` to create a new message.
 */
export const BucketedHistoryRequestSchema: GenMessage<BucketedHistoryRequest> = /*@__PURE__*/
  messageDesc(file_history, 0);

/**
 * @generated from message history.v1.RunBucketedHistory
 */
export type RunBucketedHistory = Message<"history.v1.RunBucketedHistory"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: repeated bytes specs_arrow = 2;
   */
  specsArrow: Uint8Array[];

  /**
   * @generated from field: bool incomplete = 3;
   */
  incomplete: boolean;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: optional int32 default_color_index = 6;
   */
  defaultColorIndex?: number | undefined;

  /**
   * @generated from field: optional string config = 7;
   */
  config?: string | undefined;

  /**
   * @generated from field: optional string summary = 8;
   */
  summary?: string | undefined;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string heartbeat_at = 10;
   */
  heartbeatAt: string;

  /**
   * @generated from field: string state = 11;
   */
  state: string;

  /**
   * @generated from field: optional string group_name = 12;
   */
  groupName?: string | undefined;

  /**
   * @generated from field: optional string host = 13;
   */
  host?: string | undefined;

  /**
   * @generated from field: bool stopped = 14;
   */
  stopped: boolean;

  /**
   * @generated from field: string run_id = 15;
   */
  runId: string;
};

/**
 * Describes the message history.v1.RunBucketedHistory.
 * Use `create(RunBucketedHistorySchema)` to create a new message.
 */
export const RunBucketedHistorySchema: GenMessage<RunBucketedHistory> = /*@__PURE__*/
  messageDesc(file_history, 1);

/**
 * @generated from message history.v1.BucketedHistoryResponse
 */
export type BucketedHistoryResponse = Message<"history.v1.BucketedHistoryResponse"> & {
  /**
   * @generated from field: repeated history.v1.RunBucketedHistory runs = 1;
   */
  runs: RunBucketedHistory[];

  /**
   * @generated from field: repeated string order = 2;
   */
  order: string[];
};

/**
 * Describes the message history.v1.BucketedHistoryResponse.
 * Use `create(BucketedHistoryResponseSchema)` to create a new message.
 */
export const BucketedHistoryResponseSchema: GenMessage<BucketedHistoryResponse> = /*@__PURE__*/
  messageDesc(file_history, 2);

/**
 * @generated from message history.v1.BucketedHistoryStreamHeader
 */
export type BucketedHistoryStreamHeader = Message<"history.v1.BucketedHistoryStreamHeader"> & {
  /**
   * @generated from field: repeated string order = 1;
   */
  order: string[];

  /**
   * @generated from field: repeated history.v1.RunBucketedHistory runs = 2;
   */
  runs: RunBucketedHistory[];

  /**
   * @generated from field: history.v1.BucketedHistoryBounds bounds = 3;
   */
  bounds?: BucketedHistoryBounds | undefined;
};

/**
 * Describes the message history.v1.BucketedHistoryStreamHeader.
 * Use `create(BucketedHistoryStreamHeaderSchema)` to create a new message.
 */
export const BucketedHistoryStreamHeaderSchema: GenMessage<BucketedHistoryStreamHeader> = /*@__PURE__*/
  messageDesc(file_history, 3);

/**
 * @generated from message history.v1.BucketedHistoryBounds
 */
export type BucketedHistoryBounds = Message<"history.v1.BucketedHistoryBounds"> & {
  /**
   * @generated from field: string x_axis = 1;
   */
  xAxis: string;

  /**
   * @generated from field: optional double min_x = 2;
   */
  minX?: number | undefined;

  /**
   * @generated from field: optional double max_x = 3;
   */
  maxX?: number | undefined;
};

/**
 * Describes the message history.v1.BucketedHistoryBounds.
 * Use `create(BucketedHistoryBoundsSchema)` to create a new message.
 */
export const BucketedHistoryBoundsSchema: GenMessage<BucketedHistoryBounds> = /*@__PURE__*/
  messageDesc(file_history, 4);

/**
 * @generated from message history.v1.BucketedHistorySpecResult
 */
export type BucketedHistorySpecResult = Message<"history.v1.BucketedHistorySpecResult"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: uint32 spec_index = 2;
   */
  specIndex: number;

  /**
   * @generated from field: bytes spec_arrow = 3;
   */
  specArrow: Uint8Array;

  /**
   * @generated from field: bool incomplete = 4;
   */
  incomplete: boolean;
};

/**
 * Describes the message history.v1.BucketedHistorySpecResult.
 * Use `create(BucketedHistorySpecResultSchema)` to create a new message.
 */
export const BucketedHistorySpecResultSchema: GenMessage<BucketedHistorySpecResult> = /*@__PURE__*/
  messageDesc(file_history, 5);

/**
 * @generated from message history.v1.StreamBucketedHistoryResponse
 */
export type StreamBucketedHistoryResponse = Message<"history.v1.StreamBucketedHistoryResponse"> & {
  /**
   * @generated from oneof history.v1.StreamBucketedHistoryResponse.payload
   */
  payload: {
    /**
     * @generated from field: history.v1.BucketedHistoryStreamHeader header = 1;
     */
    value: BucketedHistoryStreamHeader;
    case: "header";
  } | {
    /**
     * @generated from field: history.v1.BucketedHistorySpecResult spec = 2;
     */
    value: BucketedHistorySpecResult;
    case: "spec";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message history.v1.StreamBucketedHistoryResponse.
 * Use `create(StreamBucketedHistoryResponseSchema)` to create a new message.
 */
export const StreamBucketedHistoryResponseSchema: GenMessage<StreamBucketedHistoryResponse> = /*@__PURE__*/
  messageDesc(file_history, 6);

/**
 * @generated from service history.v1.HistoryService
 */
export const HistoryService: GenService<{
  /**
   * @generated from rpc history.v1.HistoryService.GetBucketedHistory
   */
  getBucketedHistory: {
    methodKind: "unary";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof BucketedHistoryResponseSchema;
  },
  /**
   * @generated from rpc history.v1.HistoryService.StreamBucketedHistory
   */
  streamBucketedHistory: {
    methodKind: "server_streaming";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof StreamBucketedHistoryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_history, 0);

